function ___$insertStyle(css) {
  if (!css) {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

import { __assign } from 'tslib';
import hebrewDateN from 'hebrew-date';
import heDate from 'hebcal';
import gematriya from 'gematriya';
import Dayjs from 'dayjs'; // const dayjs = Dayjs.default

var HeDate = heDate;
var hebrewDate = hebrewDateN;

function isValidDate(date) {
  return date && Object.prototype.toString.call(date) === "[object Date]";
}

var isMeubar = function isMeubar(year) {
  var yearindex = year % 19;
  return yearindex === 0 || yearindex === 3 || yearindex === 6 || yearindex === 8 || yearindex === 11 || yearindex === 14 || yearindex === 17;
};

var getHebWeekdays = function getHebWeekdays() {
  return ["א", "ב", "ג", "ד", "ה", "ו", "ש"];
};

var getEngWeekdays = function getEngWeekdays() {
  return ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
};

var getWeekdays = function getWeekdays(isHebrew) {
  return isHebrew ? getHebWeekdays() : getEngWeekdays();
};

var convertToHebrew = function convertToHebrew(num, addGeresh, addPunctuate) {
  if (addGeresh === void 0) {
    addGeresh = true;
  }

  if (addPunctuate === void 0) {
    addPunctuate = true;
  }

  return gematriya(num, {
    geresh: addGeresh,
    punctuate: addPunctuate
  });
};

var getHebJewishMonthById = function getHebJewishMonthById(monthId) {
  var months = getHebJewishMonths();
  var monthIndex = months.map(function (month) {
    return month.id;
  }).indexOf(monthId);
  return months[monthIndex].text;
};

var getHebJewishMonths = function getHebJewishMonths() {
  return [{
    id: "Tishri",
    text: "תשרי"
  }, {
    id: "Heshvan",
    text: "חשון"
  }, {
    id: "Kislev",
    text: "כסלו"
  }, {
    id: "Tevet",
    text: "טבת"
  }, {
    id: "Shevat",
    text: "שבט"
  }, {
    id: "AdarI",
    text: "אדר א"
  }, {
    id: "AdarII",
    text: "אדר ב"
  }, {
    id: "Nisan",
    text: "ניסן"
  }, {
    id: "Iyyar",
    text: "אייר"
  }, {
    id: "Sivan",
    text: "סיון"
  }, {
    id: "Tammuz",
    text: "תמוז"
  }, {
    id: "Av",
    text: "אב"
  }, {
    id: "Elul",
    text: "אלול"
  }];
};

var getEngJewishMonths = function getEngJewishMonths() {
  return [{
    id: "Tishri",
    text: "Tishri"
  }, {
    id: "Heshvan",
    text: "Heshvan"
  }, {
    id: "Kislev",
    text: "Kislev"
  }, {
    id: "Tevet",
    text: "Tevet"
  }, {
    id: "Shevat",
    text: "Shevat"
  }, {
    id: "AdarI",
    text: "AdarI"
  }, {
    id: "AdarII",
    text: "AdarII"
  }, {
    id: "Nisan",
    text: "Nisan"
  }, {
    id: "Iyyar",
    text: "Iyyar"
  }, {
    id: "Sivan",
    text: "Sivan"
  }, {
    id: "Tammuz",
    text: "Tammuz"
  }, {
    id: "Av",
    text: "Av"
  }, {
    id: "Elul",
    text: "Elul"
  }];
};

var getJewishMonths = function getJewishMonths(year, isHebrew) {
  var months = isHebrew ? getHebJewishMonths() : getEngJewishMonths();

  if (isMeubar(year)) {
    return months;
  } else {
    return months.filter(function (month) {
      return month.id !== "AdarII";
    }).map(function (month) {
      if (month.id == "AdarI") {
        return {
          id: "AdarI",
          text: isHebrew ? "אדר" : "Adar"
        };
      } else {
        return month;
      }
    });
  }
};

var getJewishYears = function getJewishYears(year) {
  if (year === void 0) {
    year = 5780;
  }

  var years = [];

  for (var i = 100; i > 0; i--) {
    var element = year - i;
    years.push(element);
  }

  years.push(year);

  for (var i = 1; i <= 100; i++) {
    var element = year + i;
    years.push(element);
  }

  return years;
};

var getPrevMonth = function getPrevMonth(basicJewishMonthInfo) {
  var result = __assign({}, basicJewishMonthInfo);

  var months = getJewishMonths(basicJewishMonthInfo.year, basicJewishMonthInfo.isHebrew);
  var monthIndex = months.map(function (month) {
    return month.id;
  }).indexOf(basicJewishMonthInfo.month);

  if (monthIndex !== -1) {
    if (monthIndex === 0) {
      result.month = months[months.length - 1].id;
      result.year--;
    } else {
      result.month = months[monthIndex - 1].id;
    }
  }

  return result;
};

var getNextMonth = function getNextMonth(basicJewishMonthInfo) {
  var result = __assign({}, basicJewishMonthInfo);

  var months = getJewishMonths(basicJewishMonthInfo.year);
  var monthIndex = months.map(function (month) {
    return month.id;
  }).indexOf(basicJewishMonthInfo.month);

  if (monthIndex !== -1) {
    if (monthIndex === months.length - 1) {
      result.month = months[0].id;
      result.year++;
    } else {
      result.month = months[monthIndex + 1].id;
    }
  }

  return result;
};

var getGregDate = function getGregDate(props) {
  if (!props || props.monthName === "" || props.year < 1 || props.day < 1) {
    return new Date();
  }

  if (props.monthName === "Heshvan") {
    props.monthName = "Cheshvan";
  }

  var day = new HeDate.HDate(props.day, props.monthName, props.year);
  return day.greg();
};

var getJewishMonthInfo = function getJewishMonthInfo(date) {
  var jewishDate = getJewishDate(date);
  var startOfJewishMonth = Dayjs(date).subtract(jewishDate.day - 1, "day");
  var dayOfWeek = Number(startOfJewishMonth.format("d"));
  var sundayStartOfTheMonth = startOfJewishMonth.subtract(dayOfWeek, "day");
  return {
    jewishDate: jewishDate,
    jewishMonth: jewishDate.month,
    startOfJewishMonth: startOfJewishMonth,
    sundayStartOfTheMonth: sundayStartOfTheMonth
  };
};

var formatJewishDate = function formatJewishDate(jewishDate) {
  return "".concat(jewishDate.day, " ").concat(jewishDate.monthName, " ").concat(jewishDate.year);
};

var formatJewishDateHebrew = function formatJewishDateHebrew(jewishDate) {
  return "".concat(convertToHebrew(jewishDate.day), " ").concat(getHebJewishMonthById(jewishDate.monthName), " ").concat(convertToHebrew(jewishDate.year));
};

var getJewishDate = function getJewishDate(date) {
  var hebDate = hebrewDate(date);
  return {
    year: hebDate.year,
    month: hebDate.month,
    day: hebDate.date,
    monthName: hebDate.month_name
  };
};

var IsJewishDatesEqual = function IsJewishDatesEqual(jewishDate1, jewishDate2) {
  return jewishDate1 && jewishDate2 && jewishDate1.day === jewishDate2.day && jewishDate1.month === jewishDate2.month && jewishDate1.year === jewishDate2.year;
};

var getJewishDay = function getJewishDay(dayjsDate) {
  var jewishDate = getJewishDate(dayjsDate.toDate());
  var day = {
    day: jewishDate.day,
    jewishDateStr: formatJewishDate(jewishDate),
    jewishDateStrHebrew: formatJewishDateHebrew(jewishDate),
    jewishDate: jewishDate,
    dayjsDate: dayjsDate,
    date: dayjsDate.toDate(),
    isCurrentMonth: false
  };
  return day;
};

var getJewishMonth = function getJewishMonth(date) {
  var jewishMonthInfo = getJewishMonthInfo(date);
  var jewishMonth = {
    selectedDay: null,
    jewishMonth: jewishMonthInfo.jewishMonth,
    jewishYear: jewishMonthInfo.jewishDate.year,
    jewishMonthString: jewishMonthInfo.jewishDate.monthName,
    days: []
  };
  var currentDate = jewishMonthInfo.sundayStartOfTheMonth;

  for (var i = 0; i < 42; i++) {
    var day = getJewishDay(currentDate);
    day.isCurrentMonth = jewishMonth.jewishMonth === day.jewishDate.month;

    if (IsJewishDatesEqual(jewishMonthInfo.jewishDate, day.jewishDate)) {
      jewishMonth.selectedDay = day;
    }

    if (i < 7 || day.isCurrentMonth || day.date.getDay() > 0) {
      jewishMonth.days.push(day);
      currentDate = currentDate.add(1, "day");
    }
  }

  return jewishMonth;
};

var getHolidays = function getHolidays(isIsrael) {
  var holidays = ['1 Tishri', '2 Tishri', '10 Tishri', '15 Tishri', '22 Tishri', '15 Nisan', '21 Nisan', '6 Sivan'];

  if (!isIsrael) {
    holidays.push('16 Tishri', '23 Tishri', '16 Nisan', '22 Nisan', '7 Sivan');
  }

  return holidays;
};

var dontSelectHolidays = function dontSelectHolidays(isIsrael) {
  var holidays = getHolidays(isIsrael);
  return function (day) {
    return !holidays.includes("".concat(day.jewishDate.day, " ").concat(day.jewishDate.monthName));
  };
};

var dontSelectShabat = function dontSelectShabat(day) {
  var dayOfWeek = day.date.getDay();
  return dayOfWeek !== 6;
};

var dontSelectShabatAndHolidays = function dontSelectShabatAndHolidays(isIsrael) {
  return function (day) {
    return dontSelectShabat(day) && dontSelectHolidays(isIsrael)(day);
  };
};

var dontSelectOutOfRange = function dontSelectOutOfRange(minDate, maxDate) {
  var min = minDate && Dayjs(minDate).subtract(1, 'day').startOf('date');
  var max = maxDate && Dayjs(maxDate).add(1, 'day').startOf('date');
  return function (day) {
    var date = Dayjs(day.date).startOf('date');

    if (min && max) {
      return date.isAfter(min) && date.isBefore(max);
    } else if (min) {
      return date.isAfter(min);
    } else if (max) {
      return date.isBefore(max);
    }

    return false;
  };
};

var addDates = function addDates(date, numDays) {
  var formatedDate = isValidDate(date) ? date : getGregDate(date);
  return Dayjs(formatedDate).add(numDays, 'day').toDate();
};

var subtractDates = function subtractDates(date, numDays) {
  var formatedDate = isValidDate(date) ? date : getGregDate(date);
  return Dayjs(formatedDate).subtract(numDays, 'day').toDate();
};

export { IsJewishDatesEqual, addDates, convertToHebrew, dontSelectHolidays, dontSelectOutOfRange, dontSelectShabat, dontSelectShabatAndHolidays, formatJewishDate, formatJewishDateHebrew, getEngJewishMonths, getEngWeekdays, getGregDate, getHebJewishMonthById, getHebJewishMonths, getHebWeekdays, getHolidays, getJewishDate, getJewishDay, getJewishMonth, getJewishMonthInfo, getJewishMonths, getJewishYears, getNextMonth, getPrevMonth, getWeekdays, isMeubar, isValidDate, subtractDates };